module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAA1klEQVRIie3WMQ6FIAwG4J+Xt3AEXVjt/Q+DK4scoSNv0ryYQkEIk92Etp+QKBjokdSElExpvjSpNq/FpMHm5hp2R7oBCfpHhgF36FuTvK4rnHOw1l5jzIwQAo7jUOvPlYirkJrfQ8NSSsaUgG3b1Lc8Y9/3LPTJFTnnqgEtX0SIqLhFUlhrQUT1yLIsTYBWl92ukfEi/UiM8VGzXJ2IeO/BzE0AM8N7X48AQAihCSnlT/t3Xc+5RkQkfmgxxuwWnQAw6TyZfjIOg7Qzvgtrua08gkp3rx+Gg3P/0bOh/wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/images/elevator-icon.png
// module id = 545
// module chunks = 0